export default "__VITE_ASSET__2a1effc3__"